export default __webpack_public_path__ + "static/media/exchange icon.1c470af1.svg";